// This file is shared across the demos.

import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Home from '@material-ui/icons/Home';
import AccessTime from '@material-ui/icons/AccessTime';
import CreditCard from '@material-ui/icons/CreditCard';
import Call from '@material-ui/icons/Call';
import AccountBox from '@material-ui/icons/AccountBox';
import Settings from '@material-ui/icons/Settings';
import Mail from '@material-ui/icons/Mail';

import Help from "@material-ui/icons/Help";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import { auth, usersRef } from "./firebase";

import { toast } from "react-toastify";

export const menuItems = (
    <div >
        <Link to='/invites' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <Mail />
                </ListItemIcon>
                <ListItemText primary="My Invites" />
            </ListItem>
        </Link>
        <Link to='/kids' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <Home />
                </ListItemIcon>
                <ListItemText primary="Kids" />
            </ListItem>
        </Link>
        <Link to='/events/' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <AccessTime />
                </ListItemIcon>
                <ListItemText primary="Events" />
            </ListItem>
        </Link>
        <Link to='/payments' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <CreditCard />
                </ListItemIcon>
                <ListItemText primary="Transactions" />
            </ListItem>
        </Link>
        <Link to='/contacts' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <Call />
                </ListItemIcon>
                <ListItemText primary="Contacts" />
            </ListItem>
        </Link>
        <Link to='/account' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <AccountBox />
                </ListItemIcon>
                <ListItemText primary="Account" />
            </ListItem>
        </Link>
        <Link to='/settings' style={{ textDecoration: 'none' }}>
            <ListItem button>
                <ListItemIcon>
                    <Settings />
                </ListItemIcon>
                <ListItemText primary="Settings" />
            </ListItem>
        </Link>


        <Divider />


        < ListItem button>
            <ListItemIcon>
                <Help />
            </ListItemIcon>
            <ListItemText primary="Help" />
        </ListItem>
    </div>
);


{/* 

 <ListItem
      button
      onClick={() => {
        auth.signOut().then(() => {
        //    Push.create("KBAAZ", {
        //           body: "Logout successful!!!",
        //           logo: './k-logo.png',
        //           timeout: 4000,
        //           onClick: function () {
        //             window.focus();
        //             this.close();
        //           }
        //         }); 
//     toast.success("Logout successful!", {
//         position: "bottom-right",
//         autoClose: 5000,
//         hideProgressBar: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true
//     });
// });
//           }}
        >
        <ListItemIcon>
            <ExitToApp />
        </ListItemIcon>
        <ListItemText primary="Logout" />
        </ListItem >

*/}


// WEBPACK FOOTER //
// ./src/tileData.js